module.exports = __webpack_public_path__ + "static/media/error403.2dda86ad.svg";